import React, { PureComponent } from 'react';
import './Dropdown.scss';

export default class Dropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: this.props.defaultLabel,
    };
  }
  componentDidMount() {
    const { list, selectedPowerFromUrl } = this.props;
    const selectedPower = (Math.round(selectedPowerFromUrl * 100) / 100).toFixed(2);
    const isSelectedPowerValidInUrl = list && list.includes(selectedPower);
    if (isSelectedPowerValidInUrl && selectedPowerFromUrl) {
      this.resetValue(selectedPower);
    }
  }

  componentDidUpdate() {
    const { defaultLabel } = this.props;
    if (this.props.isDisabled === '0') {
      this.resetValue(defaultLabel);
    }
  }

  resetValue = val => {
    this.setState({ defaultValue: val });
  };

  select = (props, item) => {
    this.setState(
      {
        defaultValue: item,
      },
      () => {
        this.props.handleProductList(props, item);
        //    this.props.productCallsAction.handleClDropdownOpenList('');
      }
    );
  };

  renderListItems() {
    const items = [];
    for (let index = 0; index < this.props?.list?.length; index += 1) {
      const item = this.props?.list?.[index];
      if (
        (item > 0 && !items.length) ||
        (item > 0 && items.length && items.toString().indexOf('positive') === -1)
      ) {
        items.push(' positive');
      } else if (
        (item < 0 && !items.length) ||
        (item < 0 && items.length && items.toString().indexOf('negative') === -1)
      ) {
        items.push(' negative');
      }
    }
    if (items.length > 1) {
      items.push(' both');
    } else {
      items.push(' single');
    }
    return items.toString().replace(/,/g, '');
  }

  render() {
    const { isJitProduct, isDisabled, power, name, openList, list, openDropdown, errPowerList } =
      this.props;
    const { defaultValue } = this.state;
    return (
      <div
        className={
          !isJitProduct && errPowerList && errPowerList.includes(`${power}-${name}`)
            ? 'err-dd dd-container'
            : 'dd-container'
        }
      >
        <div
          className={
            isDisabled === '0' ? 'disabled custom-dropdown cl-dd' : 'custom-dropdown cl-dd'
          }
        >
          <div
            className={
              `${power}-${name}` === openList
                ? ' cl-dd dropdown-container show'
                : ' dropdown-container cl-dd'
            }
          >
            <div
              className={
                `${power}-${name}` === openList
                  ? ' dropdown-display clicked cl-dd'
                  : ' dropdown-display cl-dd'
              }
              onClick={() => {
                openDropdown(this.props, `${power}-${name}`);
              }}
            >
              <span className="cl-dd">
                {defaultValue !== 'Please select' && isDisabled !== '0'
                  ? defaultValue
                  : this.props.defaultLabel}
              </span>
              <i
                aria-hidden="true"
                className={
                  `${power}-${name}` === openList
                    ? 'fa fa-chevron-up cl-dd'
                    : 'fa fa-chevron-down cl-dd'
                }
              ></i>
            </div>
            {`${power}-${name}` === openList && (
              <div className={`dropdown-list${this.renderListItems()}`}>
                {/* {defaultValue !== 'Please select' && <span onClick={() => { this.select(this.props, 'Please select'); }} className="dropdown-display list-opened">{this.props.defaultLabel} <i className={(defaultValue !== 'Please select' || defaultValue !== 'Select') ? 'pull-right padding-t8 padding-r10' : 'fa fa-chevron-down pull-right padding-t8 padding-r10'} aria-hidden="true"></i></span>} */}
                {isNaN(list?.[0] && list?.[0].toString()) && (
                  <ul className="color-list list pull-left">
                    {list &&
                      list.map((item, key) => {
                        return (
                          <li key={`color${key}`}>
                            <div
                              onClick={() => {
                                this.select(this.props, item);
                              }}
                            >
                              {item}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                )}
                {!isNaN(list?.[0] && list?.[0].toString()) && (
                  <div className="cl-power-list">
                    {list &&
                      list.map((item, key) => {
                        if (item === '0.00' || item === '0' || item === 0.0 || item === 0) {
                          return (
                            <ul key={key} className="list pull-left zero full-width">
                              <li key={`negative${key}`}>
                                <div
                                  onClick={() => {
                                    this.select(this.props, item);
                                  }}
                                >
                                  {item}
                                </div>
                              </li>
                            </ul>
                          );
                        }
                        return null;
                      })}
                    <ul className={`negative-list list pull-left ${power}`}>
                      {list &&
                        list.map((item, key) => {
                          if (item < 0) {
                            return (
                              <li key={`negative${key}`}>
                                <div
                                  onClick={() => {
                                    this.select(this.props, item);
                                  }}
                                >
                                  {item}
                                </div>
                              </li>
                            );
                          }
                          return null;
                        })}
                    </ul>
                    <ul className={`positive-list list pull-left ${power}`}>
                      {list &&
                        list.map((item, key) => {
                          if (item > 0) {
                            return (
                              <li key={`positive${key}`}>
                                <div
                                  onClick={() => {
                                    this.select(this.props, item);
                                  }}
                                >
                                  {item}
                                </div>
                              </li>
                            );
                          }
                          return null;
                        })}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
